import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';
import { AuthorizationUtility } from './auth.utility';
import { AllowListAuthStore } from './allow-list-auth.store';

@Directive({
  standalone: true,
  selector: '[authorizeFieldView]',
})
export class AuthorizeFieldViewDirective implements OnDestroy {
  private hasView = false;
  private id!: string;
  private pageId!: string;
  private tabId!: string;
  private section!: string;
  private configSub: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authUtility: AuthorizationUtility,
    private authStore: AllowListAuthStore
  ) {
    // Re-evaluate whenever auth config reloads
    this.configSub = this.authStore.loaded$.pipe(skip(1)).subscribe(() => {
      if (this.pageId) this.handleView();
    });
  }

  ngOnDestroy(): void {
    this.configSub.unsubscribe();
  }

  @Input() set authorizeFieldView(config: string[]) {
    this.pageId = config[0];
    this.tabId = config[1];
    this.id = config[2];
    this.section = config[3];
    this.handleView();
  }

  private handleView() {
    if (!this.id || !this.pageId) {
      this.viewContainer.clear();
      this.hasView = false;
      return;
    }

    const hasAccess = this.authUtility.isFieldReadable(this.pageId, this.tabId, this.section, this.id);

    if (hasAccess && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasAccess && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
